import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Textfield from "../components/Textfield";
import { useNavigate } from "react-router-dom";
import Button from "../components/Buttons";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";
import { ForgotValidation } from "../helper";
import { userForgotPassword } from "../services/userServices";
import { toast } from "react-toastify";
import ToastMessage from "../components/ToastMessage";
import CustomLoader from "../components/Loader";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
const loginBg = require("../assets/images/Loginbg.png");

const ForgotPassword = () => {
  let navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Forgot Password Page" });
  }, []);

  const forgotPassword = async (user) => {
    setLoading(true);
    try {
      const response = await userForgotPassword(user);
      if (response.status === 200) {
        console.log("response", response.data);
        localStorage.setItem("userID", response.data.userId);
        // localStorage.setItem("name", response.data.name);
        // localStorage.setItem("email", response.data.name);
        // localStorage.setItem("name", response.data.name);
        toast.success(response.data.message, { hideProgressBar: true });

        navigate(`/auth/otp?email=${email}`);
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let user;
    user = { email: email };
    const isValid = ForgotValidation(user, setError);
    if (isValid) {
      forgotPassword(user);
    }
  };

  return (
    <ForgotStyled>
      <ForgotModal>
        <InnerDiv>
          <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
          <HeaderRight>{Text.forgotPinHeader}</HeaderRight>
          <SubEmailHeader>{Text.forgotSubHeader}</SubEmailHeader>
          {loading ? (
            <CustomLoader />
          ) : (
            <ForgotForm>
              <TextFieldSpace>
                <Textfield
                  placeholder={Text.loginEmailPlaceholder}
                  variant="Email id"
                  value={email}
                  size="large"
                  isRounded={true}
                  error={error.email ? true : false}
                  onChange={(e) => {
                    setError((prevState) => {
                      return { ...prevState, email: "" };
                    });
                    setEmail(e.target.value);
                  }}
                  type="text"
                  color={Colors.secondaryBlack}
                  placeholderColor={Colors.santasGray}
                />
                {error.email && <ErrorMessage>{error.email}</ErrorMessage>}
              </TextFieldSpace>
              <AddSpace>
                <Button
                  label="Submit"
                  variant="filled"
                  color={Colors.aqua}
                  size="large"
                  onClick={(e) => handleSubmit(e)}
                />
                <SubHeaderRight>{Text.forgotSubHeader1}</SubHeaderRight>
              </AddSpace>
            </ForgotForm>
          )}
        </InnerDiv>
      </ForgotModal>
    </ForgotStyled>
  );
};

export default ForgotPassword;

const ForgotStyled = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url(${loginBg}); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
const ForgotModal = styled.div`
  width: 31.7rem;
  border-radius: 0.5rem;
  background: ${Colors.whiteSmoke};
  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const InnerDiv = styled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Logo = styled.img`
  height: 4rem;
  resize: contain;
`;
const HeaderRight = styled.div`
  font-size: 1.5rem;
  color: ${Colors.black};
  margin-top: 1.2rem;
  font-weight: 600;
`;
const SubHeaderRight = styled.div`
  font-size: 0.875rem;
  color: ${Colors.black};
  margin-top: 1rem;
  margin-bottom: 1rem;
  /* padding: 0rem 1rem 0rem 1rem; */
  text-align: center;
  @media only screen and (max-width: 768px) {
    padding: 0rem 0.5 0rem 0.5rem;
  }
`;
const SubEmailHeader = styled.div`
  font-size: 0.875rem;
  color: ${Colors.black};
  margin-top: 1.2rem;
  padding: 0rem 10rem 0rem 10rem;
  text-align: center;
  @media only screen and (max-width: 768px) {
    padding: 0rem 2rem 0rem 2rem;
  }
`;
const ForgotForm = styled.form`
  width: 100%;
  display: flex;
  padding: 0rem 8rem 0rem 8rem;
  box-sizing: border-box;
  flex-direction: column;
  @media only screen and (max-width: 540px) {
    padding: 0rem 4rem 0rem 4rem;
  }
  @media only screen and (max-width: 300px) {
    padding: 0rem 2rem 0rem 2rem;
  }
`;
const ErrorMessage = styled.div`
  font-family: "Poppins";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  position: absolute;
  margin-top: 0.25rem;
`;

const TextFieldSpace = styled.span`
  margin-top: 1rem;
`;

const AddSpace = styled.span`
  margin-top: 3rem;
  margin-bottom: 4rem;
`;
